(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const root = document.querySelector('[data-product-information-post-content]');
      if (!root) return;

      const videos = Array.from(root.querySelectorAll('[data-autoplay-video]')).filter(
        (video) => video instanceof HTMLVideoElement
      );
      if (!videos.length) return;

      const playVideo = (video) => {
        video.muted = true;
        video.playsInline = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      if (!('IntersectionObserver' in window)) {
        videos.forEach(playVideo);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (!(video instanceof HTMLVideoElement)) return;

            if (entry.isIntersecting) {
              playVideo(video);
            } else {
              video.pause();
            }
          });
        },
        {
          threshold: 0.35,
        }
      );

      videos.forEach((video) => observer.observe(video));

      const setupJudgeMeReviewFallback = () => {
        const reviewWidget = root.querySelector('.jdgm-widget.jdgm-review-widget');
        let reviewRoot = reviewWidget?.querySelector('.jdgm-rev-widg');
        const productId = reviewWidget?.dataset.id;
        if (!reviewWidget || !productId || reviewWidget.dataset.fallbackBound == 'true') return false;

        const formatDate = (value) => {
          const date = new Date(value);
          if (Number.isNaN(date.getTime())) return '';

          return date.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          });
        };

        const renderStars = (rating) => {
          const fullStars = Math.max(0, Math.min(5, Number(rating) || 0));

          return Array.from({ length: 5 }, (_, index) => {
            const state = index < fullStars ? 'on' : 'off';
            return `<span class="jdgm-star jdgm--${state}"></span>`;
          }).join('');
        };

        const escapeAttribute = (value) =>
          String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');

        const getReviewPictureUrl = (picture, preferredSize = 'small') => {
          if (!picture) return '';
          if (typeof picture === 'string') return picture;

          return picture[preferredSize] || picture.compact || picture.small || picture.original || picture.huge || '';
        };

        const renderReviewPictures = (review) => {
          const pictures = Array.isArray(review.pictures_urls) ? review.pictures_urls : [];
          if (!pictures.length) return '';

          const pictureMarkup = pictures
            .map((picture, index) => {
              const imageUrl = getReviewPictureUrl(picture, 'small');
              const fullImageUrl = getReviewPictureUrl(picture, 'original') || imageUrl;
              if (!imageUrl) return '';

              const altText = `Review image ${index + 1}`;

              return `
                <a class="jdgm-rev__pic-link" href="${escapeAttribute(fullImageUrl)}" target="_blank" rel="noopener" aria-label="${altText}">
                  <img class="jdgm-rev__pic-img" src="${escapeAttribute(imageUrl)}" alt="${altText}" loading="lazy">
                </a>
              `;
            })
            .join('');

          return pictureMarkup ? `<div class="jdgm-rev__pics">${pictureMarkup}</div>` : '';
        };

        const renderReview = (review) => {
          const reviewerInitial = review.reviewer_initial || review.reviewer_name?.charAt(0) || '';

          return `
            <div
              class="jdgm-rev jdgm-divider-top jdgm--done-setup"
              data-review-id="${review.uuid}"
              data-review-language="${review.language || ''}"
              data-product-title="${review.product_title || ''}"
              data-product-url="${review.product_url || ''}"
              data-thumb-up-count="${review.thumb_up || 0}"
              data-thumb-down-count="${review.thumb_down || 0}"
            >
              <div class="jdgm-rev__header">
                <div class="jdgm-row-product"></div>
                <div class="jdgm-row-rating">
                  <span class="jdgm-rev__rating" data-score="${review.rating}" tabindex="0" aria-label="${review.rating} star review" role="img">
                    ${renderStars(review.rating)}
                  </span>
                  <span class="jdgm-rev__timestamp" data-content="${review.created_at}">${formatDate(review.created_at)}</span>
                </div>
                <div class="jdgm-row-profile">
                  <div class="jdgm-rev__icon">${reviewerInitial}</div>
                  <span class="jdgm-rev__author-wrapper">
                    <span class="jdgm-rev__author">${review.reviewer_name || ''}</span>
                  </span>
                </div>
                <div class="jdgm-row-extra">
                  <span class="jdgm-rev__location"></span>
                </div>
                <div class="jdgm-rev__br"></div>
              </div>
              <div class="jdgm-rev__content">
                <b class="jdgm-rev__title">${review.title || ''}</b>
                <div class="jdgm-rev__body">${review.body_html || ''}</div>
                ${renderReviewPictures(review)}
                <div class="jdgm-rev__custom-form"></div>
              </div>
            </div>
          `;
        };

        const renderHistogram = (histogram = []) => {
          const rows = histogram
            .map((row) => {
              const rating = Number(row.rating) || 0;
              const frequency = Number(row.frequency) || 0;
              const percentage = Number(row.percentage) || 0;

              return `
                <div class="jdgm-histogram__row" data-rating="${rating}">
                  <div class="jdgm-histogram__star" role="button" tabindex="0" aria-label="Filter by ${rating} star reviews">
                    ${renderStars(rating)}
                  </div>
                  <div class="jdgm-histogram__bar">
                    <div class="jdgm-histogram__bar-content" style="width: ${percentage}%"></div>
                  </div>
                  <div class="jdgm-histogram__frequency">${frequency}</div>
                </div>
              `;
            })
            .join('');

          return `
            <div class="jdgm-histogram">
              ${rows}
              <div class="jdgm-histogram__row jdgm-histogram__clear-filter" role="button" tabindex="0" style="display: none;">Clear filter</div>
            </div>
          `;
        };

        const renderReviewRoot = (data) => {
          const averageRating = Number(data.average_rating || 0);
          const numberOfReviews = Number(data.number_of_reviews || 0);
          const summaryText = data.review_summary_text || `Based on ${numberOfReviews} reviews`;

          return `
            <div
              class="jdgm-rev-widg jdgm--done-setup"
              data-average-rating="${averageRating}"
              data-number-of-reviews="${numberOfReviews}"
            >
              <div class="jdgm-rev-widg__header">
                <h2 class="jdgm-rev-widg__title">Customer Reviews</h2>
                <div class="jdgm-rev-widg__summary">
                  <div class="jdgm-rev-widg__summary-stars" aria-label="Average rating ${averageRating} out of 5" role="img">
                    ${renderStars(Math.round(averageRating))}
                  </div>
                  <div class="jdgm-rev-widg__summary-text">${summaryText}</div>
                </div>
                ${renderHistogram(data.histogram)}
              </div>
              <div class="jdgm-rev-widg__body">
                <div class="jdgm-rev-widg__sort-wrapper">
                  <select class="jdgm-sort-dropdown" aria-label="Sort reviews">
                    <option value="created_at" selected>Most recent</option>
                    <option value="highest-rating">Highest rating</option>
                    <option value="lowest-rating">Lowest rating</option>
                  </select>
                </div>
                <div class="jdgm-rev-widg__reviews"></div>
              </div>
            </div>
          `;
        };

        const buildPaginationModel = (currentPage, totalPages) => {
          if (!totalPages || totalPages <= 1) return [];

          if (totalPages <= 3) {
            return Array.from({ length: totalPages }, (_, index) => index + 1);
          }

          if (currentPage <= 1) return [1, 2, 3];
          if (currentPage >= totalPages) return [Math.max(1, totalPages - 2), Math.max(1, totalPages - 1), totalPages];

          return [Math.max(1, currentPage - 1), currentPage, Math.min(totalPages, currentPage + 1)];
        };

        const renderPagination = (pagination) => {
          const totalPages = pagination?.total_pages || 1;
          const currentPage = pagination?.current_page || 1;
          if (totalPages <= 1) return '';

          const pageButtons = buildPaginationModel(currentPage, totalPages)
            .map((pageNumber) => {
              const activeClass = pageNumber === currentPage ? ' jdgm-curt' : '';
              return `<a class="jdgm-paginate__page${activeClass}" role="button" tabindex="0" aria-label="Page ${pageNumber}" data-page="${pageNumber}">${pageNumber}</a>`;
            })
            .join('');

          const nextPage = Math.min(totalPages, currentPage + 1);

          return `
            <div class="jdgm-paginate" data-per-page="${pagination.per_page || 5}">
              ${pageButtons}
              ${currentPage < totalPages ? `<a class="jdgm-paginate__page jdgm-paginate__next-page" role="button" tabindex="0" aria-label="Page ${nextPage}" data-page="${nextPage}"></a>` : ''}
              ${currentPage < totalPages ? `<a class="jdgm-paginate__page jdgm-paginate__last-page" role="button" tabindex="0" aria-label="Page ${totalPages}" data-page="${totalPages}"></a>` : ''}
            </div>
          `;
        };

        const updateHistogramState = (filterRating) => {
          if (!reviewRoot) return;

          const histogramRows = reviewRoot.querySelectorAll('.jdgm-histogram__row');
          histogramRows.forEach((row) => {
            const isClearRow = row.classList.contains('jdgm-histogram__clear-filter');
            const isSelected = !isClearRow && String(row.dataset.rating || '') === String(filterRating || '');
            row.classList.toggle('jdgm-histogram__row--selected', isSelected);

            if (isClearRow) {
              row.style.display = filterRating ? '' : 'none';
            }
          });
        };

        const getSortValue = () => {
          const sortDropdown = reviewWidget.querySelector('.jdgm-sort-dropdown');
          if (!(sortDropdown instanceof HTMLSelectElement)) return null;

          return sortDropdown.value || sortDropdown.options[sortDropdown.selectedIndex]?.value || null;
        };

        const fetchAndRenderReviews = async ({ page, filterRating, clearFilter, sortBy } = {}) => {
          const searchParams = new URLSearchParams({
            url: '4qk4cw-r1.myshopify.com',
            shop_domain: '4qk4cw-r1.myshopify.com',
            platform: 'shopify',
            product_id: productId,
            per_page: reviewRoot?.querySelector('.jdgm-paginate')?.dataset.perPage || '5',
          });

          const activePage = page || '1';
          searchParams.set('page', activePage);

          const currentSort = sortBy || getSortValue();
          if (currentSort) searchParams.set('sort_by', currentSort);

          if (clearFilter) {
            reviewWidget.dataset.filterRating = '';
          } else if (filterRating) {
            reviewWidget.dataset.filterRating = String(filterRating);
          }

          const activeFilter = reviewWidget.dataset.filterRating;
          if (activeFilter) searchParams.set('filter_rating', activeFilter);

          const response = await fetch(`https://api.judge.me/reviews/reviews_for_widget?${searchParams.toString()}`);
          if (!response.ok) return;

          const data = await response.json();
          if (!reviewRoot) {
            reviewWidget.innerHTML = renderReviewRoot(data);
            reviewRoot = reviewWidget.querySelector('.jdgm-rev-widg');
          }

          if (!reviewRoot) return;

          const reviewsContainer = reviewRoot.querySelector('.jdgm-rev-widg__reviews');
          const bodyContainer = reviewRoot.querySelector('.jdgm-rev-widg__body');
          const existingPagination = reviewRoot.querySelector('.jdgm-paginate');
          if (!reviewsContainer || !bodyContainer) return;

          reviewsContainer.innerHTML = (data.reviews || []).map(renderReview).join('');

          const paginationMarkup = renderPagination(data.pagination);
          if (existingPagination) {
            existingPagination.outerHTML = paginationMarkup;
          } else if (paginationMarkup) {
            bodyContainer.insertAdjacentHTML('beforeend', paginationMarkup);
          }

          if (!paginationMarkup && reviewRoot.querySelector('.jdgm-paginate')) {
            reviewRoot.querySelector('.jdgm-paginate').remove();
          }

          reviewRoot.dataset.numberOfReviews = String(data.number_of_reviews || '0');
          reviewRoot.dataset.averageRating = String(data.average_rating || '0');
          updateHistogramState(activeFilter);

          if (window.jdgm?.customizeReviews) {
            window.jdgm.customizeReviews();
          }
        };

        reviewWidget.addEventListener(
          'click',
          (event) => {
            const paginationTarget = event.target.closest('.jdgm-paginate__page:not(.jdgm-curt)');
            if (paginationTarget instanceof HTMLElement) {
              event.preventDefault();
              event.stopPropagation();
              fetchAndRenderReviews({ page: paginationTarget.dataset.page || '1' });
              return;
            }

            const ratingTarget = event.target.closest('.jdgm-histogram__star');
            if (ratingTarget instanceof HTMLElement) {
              const ratingRow = ratingTarget.closest('.jdgm-histogram__row');
              if (!(ratingRow instanceof HTMLElement)) return;

              event.preventDefault();
              event.stopPropagation();
              fetchAndRenderReviews({ page: '1', filterRating: ratingRow.dataset.rating || '' });
              return;
            }

            const clearFilterTarget = event.target.closest('.jdgm-histogram__clear-filter');
            if (clearFilterTarget instanceof HTMLElement) {
              event.preventDefault();
              event.stopPropagation();
              fetchAndRenderReviews({ page: '1', clearFilter: true });
            }
          },
          true
        );

        reviewWidget.addEventListener(
          'change',
          (event) => {
            if (!(event.target instanceof HTMLSelectElement) || !event.target.closest('.jdgm-sort-dropdown')) return;

            event.preventDefault();
            event.stopPropagation();
            fetchAndRenderReviews({ page: '1', sortBy: event.target.value || null });
          },
          true
        );

        updateHistogramState(reviewWidget.dataset.filterRating || null);
        reviewWidget.dataset.fallbackBound = 'true';
        fetchAndRenderReviews({ page: '1' });
        return true;
      };

      let judgeMeAttempts = 0;
      const judgeMeTimer = window.setInterval(() => {
        judgeMeAttempts += 1;
        if (setupJudgeMeReviewFallback() || judgeMeAttempts >= 20) {
          window.clearInterval(judgeMeTimer);
        }
      }, 500);
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
